define('models/SyncModel',['underscore','ObjectModel', 'LocalStorage', 'site_vars','moment','ErrorModel'
], function (_, ObjectModel, LocalStorage, site_vars, moment, ErrorModel)
{
    //
    // Model Sync
    //

    var SyncModelPrototype = {

        name: 'SyncModel',
        route: 'apiSyncModel',
        translated:false,
        privateApi:true,
        defaults: {
            'version': false,
            'asset_version': site_vars.asset_version
        },

        initialize: function ()
        {
            var model = this;
             // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(model, arguments);
            //
            site_vars.sync_version = model.getVersion();
            model.on('change:version',model.onChangeVersion);
            model.on('change:asset_version',model.onChangeAssetVersion);
            //sync.remoteFetch({async:false});
        },
        onChangeAssetVersion:function(){
            var model = this,
                test = model.testAssetVersion();
            if(!test){
                model.softFetch();
                if(moment().diff(model.get('last_reload') || 0,'s')>60){
                    // protection contre les récurrences
                    // si on recharge à moins d'une minute d'intervale,
                    // on annule.
                    model.set('last_reload',new Date());
                    model.setLocalStorageItem();
                    window.location.reload(true);
                }else{
                    //
                    new ErrorModel('AssetInvalidationRecursion',model.toJSON());
                    return true;
                }
            }
            return test;
        },
        testAssetVersion:function(){
            return this.getAssetVersion() === site_vars.asset_version;
        },
        test:function(){
            try{
                var model = this,
                    key = model.getLocalStorageKey(),
                    item = LocalStorage.ls.getItem(key),
                    object = JSON.parse(item),
                    localVersion = !_.isNull(object) ? object.version : '-1',
                    testVersion = model.getVersion(),
                    diff = !_.isNull(object) && (localVersion != testVersion);
                model.setLocalStorageItem();
                // renvoie true en cas de différence de version entre le localStorage et la version actuelle
                return diff;
            }catch(err){
                // si le localStorage échoue
                // le test échoue
                return false;
            }
        },
        //
        getAssetVersion:function(){
            return this.get('asset_version');
        },
        getVersion:function(){
            return this.get('version');
        },
        getExpiresFromXHR:function(jqXHR){
            return '0';
        },
        onChangeVersion:function(model){
            try {
                LocalStorage.ls.clear();
            }catch(err){
            }
            site_vars.sync_version = model.getVersion();
            this.updateLocalStorageItem();
        }
    };


    var SyncModel = ObjectModel.extend(LocalStorage).extend(SyncModelPrototype);

    return SyncModel;
});

